import React, {Component} from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import CollapsePanel from './CollapsePanel';
import './style.css';

const container = connect (
  createSelector(
    (state) => ({
      subjects: _.get(state, 'subject.entities'),
      generalRecommend: _.get(state, 'subject.generalRecommend'),
    }),
    (state) => {
      return {
        ...state
      }
    }
  )
)

class SearchSideBar extends Component {

  render() {
    const {subjects, generalRecommend, title} = this.props;
    return (
      <div className="collapse-padding">
        <div className="collapse-layout">
          <CollapsePanel
            title="按學科分類"
            subjectIds={generalRecommend.data}
            subjects={subjects}/>
        </div>
      </div>
    )
  }
}

export default container(SearchSideBar)



/** WEBPACK FOOTER **
 ** ./src/app/modules/search/components/SearchSidebar.js
 **/